module.exports = __webpack_public_path__ + "static/media/android-chrome-512x512.6b2e82a0.png";